import { Box, Text } from "grommet";

interface Error {
  message: string;
}
interface Props {
  error: Error;
}
const ErrorMessage = (props: Props) => {
  const { error } = props;
  return (
    <Box round align="center" flex="shrink">
      <Box background={"status-critical"} round pad="small" animation={"pulse"}>
        <Text>Error: {error.message}</Text>
      </Box>
    </Box>
  );
};

export default ErrorMessage;
